import { LoginRequest, LoginResponse, User } from '../types';

// Demo user data
const demoUsers = [
  {
    id: '1',
    username: 'admin',
    password: 'admin123',
    role: 'admin',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z',
    email: 'admin@asknow.com',
    first_name: 'Admin',
    last_name: 'User',
  },
  {
    id: '2',
    username: 'user',
    password: 'user123',
    role: 'user',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z',
    email: 'user@asknow.com',
    first_name: 'Demo',
    last_name: 'User',
  },
  {
    id: '3',
    username: 'manager',
    password: 'manager123',
    role: 'manager',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z',
    email: 'manager@asknow.com',
    first_name: 'Manager',
    last_name: 'User',
  },
];

// Simulate API delay
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const demoAuthService = {
  // Demo login
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    await delay(800); // Simulate network delay
    
    const user = demoUsers.find(u => 
      u.username === credentials.username && 
      u.password === credentials.password
    );
    
    if (!user) {
      throw new Error('Invalid username or password');
    }
    
    if (!user.is_active) {
      throw new Error('User account is deactivated');
    }
    
    // Generate a mock JWT token
    const mockToken = `demo_token_${user.id}_${Date.now()}`;
    
    return {
      access_token: mockToken,
      token_type: 'bearer',
      user_id: user.id,
      username: user.username,
      role: user.role,
    };
  },

  // Demo get current user
  getCurrentUser: async (): Promise<User> => {
    await delay(500);
    
    // For demo purposes, return the admin user
    const adminUser = demoUsers[0];
    return {
      id: adminUser.id,
      username: adminUser.username,
      role: adminUser.role,
      is_active: adminUser.is_active,
      created_at: adminUser.created_at,
      email: adminUser.email,
      first_name: adminUser.first_name,
      last_name: adminUser.last_name,
    };
  },

  // Demo logout
  logout: async (): Promise<void> => {
    await delay(300);
    // In demo mode, just return success
  },

  // Get demo credentials for display
  getDemoCredentials: () => {
    return demoUsers.map(user => ({
      username: user.username,
      password: user.password,
      role: user.role,
    }));
  },
};
